module.exports = __webpack_public_path__ + "img/ScaleIcon.8c09b200.svg";